import { render } from "./SearchSelectedFilterButtons.vue?vue&type=template&id=1a667a78"
import script from "./SearchSelectedFilterButtons.vue?vue&type=script&lang=js"
export * from "./SearchSelectedFilterButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__